import React from 'react';
import C from 'classnames';
import { Col, Row, Card, CardBody } from 'reactstrap';
import PropTypes from 'prop-types';
import { statusColor } from 'utils';
import ConditionButtonIcon from 'components/atoms/icons/conditionButtonIcon';

const Button = ({
  status,
  selectedStatus,
  count,
  text,
  handleClick,
  ...rest
}) => {
  const color = statusColor(status);

  return (
    <button
      onClick={() => handleClick(status)}
      className={C('condition-button', {
        disabled: rest.disabled,
      })}
      {...rest}
    >
      <Card className="card-border card-shadow border-0 condition-button-card">
        <CardBody
          className={selectedStatus === status && 'condition-button-active'}
        >
          <Row>
            <Col xs={6}>
              <div className="condition-button-text">
                <div className="condition-button-status">{text}</div>
              </div>
            </Col>
            <Col xs={6}>
              <div className="condition-button-count-container">
                <div className="condition-button-background">
                  <ConditionButtonIcon color={color} />
                </div>
                <div className="condition-button-count">{count}</div>
              </div>
            </Col>
          </Row>
        </CardBody>
      </Card>
    </button>
  );
};

Button.defaultProps = {
  handleClick: () => {},
};

Button.propTypes = {
  status: PropTypes.string.isRequired,
  selectedStatus: PropTypes.string,
  count: PropTypes.number.isRequired,
  text: PropTypes.string.isRequired,
  handleClick: PropTypes.func,
};

export default Button;
